import { Card, CardContent, CardHeader } from '../../../components/Card';
import { Skeleton } from '../../../components/Skeleton';

export function RecentPatientsListSkeleton() {
  return (
    <ul className="flex flex-row gap-4 overflow-auto">
      {Array.from({ length: 5 }).map((_, idx) => (
        <li key={`patient-skeleton-${idx}`}>
          <Card className="w-96">
            <CardHeader className="flex flex-row justify-between">
              <div className="flex w-full flex-col gap-2">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-6 w-1/2" />
                </div>
                <div className="flex gap-2">
                  <Skeleton className="h-6 w-1/2" />
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <Skeleton className="h-6 w-3/4" />
            </CardContent>
          </Card>
        </li>
      ))}
    </ul>
  );
}
